export default {
  type: 'layoutColumns',
  fareItem: {},
  fareItemCallToAction: {},
  fareItemCallToActionContainer: {},
  fareItemDepartureInfo: {},
  fareItemReturnInfo: {},
  fareItemOriginDestinationImage: null,
  fareItemJourneyType: {},
  fareItemTravelClass: {},
  fareItemOriginDestination: {},
  fareItemPrice: {},
  fareItemMiles: {},
  fareItemRoute: {},
  fareBodyItem: {},
  fareFooterItem: {},
  fareImageItem: {},
  fareImageContainer: {},
  fareContentItem: {},
  fareItemAirline: {},
  fareItemDisclaimer: {},
  fareItemLastSeen: {},
  fareItemTripDuration: {},
  showOriginDestinationImage: true,
  showJourneyType: true,
  showTravelClass: true,
  showDepartureInfo: true,
  showReturnInfo: true,
  showLastSeen: false,
  showRoute: false,
  showPrice: true,
  showMiles: false,
  showFareDisclaimer: false,
  showAirline: false,
  showCallToAction: false,
  fareItemSale: {},
  showSale: false,
  showDurationTrip: false,
  showFareItemRouteBeforeDepartureInfo: false,
  showLastSeenBeforePrice: true,
  separatorDatesProps: {},
  separatorJourneyTypeProps: {},
  fareItemDepartureReturn: {},
  fareItemJourneyTypeTravelClass: {},
  onClick: (props) => props,
  callToActionOnClick: (props) => props,
  focusReferences: () => {},
  focusable: true,
  flavor: 'alliance',
  interactionHotZone: 'smart',
  usedErrorBoundary: true,
  dataTestId: '',
  data: {},
  hoverBody: undefined,
  hoverFooter: undefined,
  focusClass: null,
  onFocus: () => {},
  showJourneyTypeTravelClassAtomBeforeDeparture: false,
  experimentalRenderAtoms: false,
  availableAtomsBody: [
    'FareItemOriginDestination',
    'FareItemRoute',
    'FareItemDepartureReturnInfo',
    'FareItemJourneyTypeTravelClass'
  ],
  availableAtomsFooter: [
    'FareItemTripDuration',
    'FareItemLastSeen',
    'FareItemMiles',
    'FareItemPrice'
  ],
  availableAtomsContentSecondary: ['FareItemAirline', 'FareItemDisclaimer', 'FareItemCallToAction']
};
